import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import home from '@/pages/home'
import wsbx from '@/pages/wsbx'
import xsdc from '@/pages/xsdc'
import wyfw from '@/pages/wyfw'
import jxjl from '@/pages/jxjl'
import hqmh from '@/pages/old/hqmh'
import hqztsjk from '@/pages/old/hqztsjk'
import hqfwzx from '@/pages/old/hqfwzx'
import jdglpt from '@/pages/old/jdglpt'
import gxssglxt from '@/pages/old/gxssglxt'
import zwyy from '@/pages/old/zwyy'
import kjglxt from '@/pages/old/kjglxt'
import gjszhpt from '@/pages/old/gjszhpt'
import dzjy from '@/pages/old/dzjy'
import ydtg from '@/pages/old/ydtg'
import qjdl from '@/pages/old/qjdl'
import zyyypt from '@/pages/old/zyyypt'
import tzglxt from '@/pages/old/tzglxt'
import gxjjhglxt from '@/pages/old/gxjjhglxt'
import ywfwxt from '@/pages/old/ywfwxt'
import hdty from '@/pages/old/hdty'
import ESI from '@/pages/ESI'




Vue.use(Router)
const router= new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      redirect:'home',
      children:[{
        path: 'home',
        name: 'home',
        component: home,
      },{
        path: '/wsbx',
        name: 'wsbx',
        component: wsbx,
      },{
        path: 'xsdc',
        name: 'xsdc',
        component: xsdc,
      },{
        path: 'wyfw',
        name: 'wyfw',
        component: wyfw,
      },{
        path: 'jxjl',
        name: 'jxjl',
        component: jxjl,
      },{
        path: 'hqmh',
        name: 'hqmh',
        component: hqmh,
      },{
        path: 'hqztsjk',
        name: 'hqztsjk',
        component: hqztsjk,
      },{
        path: 'hqfwzx',
        name: 'hqfwzx',
        component: hqfwzx,
      },{
        path: 'jdglpt',
        name: 'jdglpt',
        component: jdglpt,
      },{
        path: 'gxssglxt',
        name: 'gxssglxt',
        component: gxssglxt,
      },{
        path: 'ESI',
        name: 'ESI',
        component: ESI,
      },{
        path: 'zwyy',
        name: 'zwyy',
        component: zwyy,
      },{
        path: 'kjglxt',
        name: 'kjglxt',
        component: kjglxt,
      },{
        path: 'gjszhpt',
        name: 'gjszhpt',
        component: gjszhpt,
      },{
        path: 'dzjy',
        name: 'dzjy',
        component: dzjy,
      },{
        path: 'ydtg',
        name: 'ydtg',
        component: ydtg,
      },{
        path: 'qjdl',
        name: 'qjdl',
        component: qjdl,
      },{
        path: 'zyyypt',
        name: 'zyyypt',
        component: zyyypt,
      },{
        path: 'tzglxt',
        name: 'tzglxt',
        component: tzglxt,
      },{
        path: 'gxjjhglxt',
        name: 'gxjjhglxt',
        component: gxjjhglxt,
      },{
        path: 'ywfwxt',
        name: 'ywfwxt',
        component: ywfwxt,
      },{
        path: 'hdty',
        name: 'hdty',
        component: hdty,
      }]
    }
  ]
})


// router.beforeEach((to,from,next)=>{
//   if(to.fullPath.indexOf('?')!=-1){
//     to.fullPath = to.fullPath.replace("?","&")
//   }
//   next();
// })
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js